
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[apiKey]/productGroupCalendar",
      function () {
        return require("private-next-pages/embed/[apiKey]/productGroupCalendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[apiKey]/productGroupCalendar"])
      });
    }
  